class InvoiceCreateWizardController {

  constructor($state) {
    "ngInject";

    this.$state = $state;
  }

  selectType(type) {
    switch (type) {
      case 'labor':
        this.$state.go('admin.invoice-create');
        break;
      case 'travel':
        this.$state.go('admin.invoice-create-travel');
        break;
      case 'other':
        this.$state.go('admin.invoice-create-other');
        break;
    }
  }
}

export default InvoiceCreateWizardController;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-create-wizard/invoice-create-wizard.controller.js